interface UberIconProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeClasses = {
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-12 w-12 text-sm',
  xl: 'h-16 w-16 text-xl'
}

export const UberIcon = ({ size = 'md', className = '' }: UberIconProps) => {
  const sizeClass = sizeClasses[size]
  
  return (
    <div className={`${sizeClass} bg-gradient-to-br from-black to-gray-800 rounded-full flex items-center justify-center ${className}`}>
      <span className="text-white font-bold">UBER</span>
    </div>
  )
}

export default UberIcon
